import axios from 'axios'

export interface CommunityHeaderConfig {
  type: 'default' | 'ssi' | 'custom',
  defaultHeader: {
    label: string,
    labelMobile: string,
    url: string,
    backgroundColor: string,
    linkColor: string,
    logoUrl: string
  },
  ssiHeader: {
    url: string
  },
  customHeader: {
    html: string
  }
}

export interface CommunityFooterConfig {
  type: 'default' | 'ssi' | 'custom',
  ssiFooter: {
    url: string,
  },
  customFooter: {
    html: string
  }
}

export interface EmbeddableWidgetConfig {
  id?: number
  customer?: string
  tracker_enabled?: boolean
  position: 'left' | 'right'
  community_url?: string
  powered_by_enabled?: boolean
  brand_color: string
  animation_time?: number
  trigger_text: string
  trigger_color: string
  trigger_type: 'button' | 'floating'
  header_title: string
  header_background: string
  header_color: string
  header_shadow: boolean
  card_user_avatar_radius: 'circle' | 'square' | 'rounded-square'
  card_title_color: string
  card_metadata_color: string
  card_border_color: string
  footer_configuration: string | object
}

export interface ThirdPartyScripts {
  head: string,
  bodyStart: string,
  bodyEnd: string,
  ssiUrl: string
}

export const getCommunityHeaderConfig = async (): Promise<CommunityHeaderConfig> => {
  const res = await axios.get('/configuration/getHeader')
  return res.data
}

export const updateCommunityHeaderConfig = async (header: CommunityHeaderConfig): Promise<CommunityHeaderConfig> => {
  const res = await axios.post('/configuration/updateHeader', header)
  return res.data
}

export const getCommunityFooterConfig = async (): Promise<CommunityFooterConfig> => {
  const res = await axios.get('/configuration/getFooter')
  return res.data
}

export const updateCommunityFooterConfig = async (header: CommunityFooterConfig): Promise<CommunityFooterConfig> => {
  const res = await axios.post('/configuration/updateFooter', header)
  return res.data
}

export const getThirdPartyScriptConfig = async (): Promise<ThirdPartyScripts> => {
  const res = await axios.get('/settings/thirdPartyScripts/getScripts')
  return res.data
}

export const updateThirdPartyScriptConfig = async (scripts: ThirdPartyScripts): Promise<void> => {
  await axios.post('/settings/thirdPartyScripts/update', scripts)
}

export const getEmbeddableWidgetConfig = async (): Promise<EmbeddableWidgetConfig> => {
  const res = await axios.get('/settings/conversationalWidget/config')
  return res.data
}

export const updateEmbeddableWidgetConfig = async (config: EmbeddableWidgetConfig): Promise<EmbeddableWidgetConfig> => {
  const res = await axios.post('/settings/conversationalWidget/config', config)
  return res.data
}

export const getEmbeddableWidgetBundle = async (config: EmbeddableWidgetConfig): Promise<string> => {
  const res = await axios.post('/settings/conversationalWidget/bundleContent', config)
  return res.data
}
